<template>
  <div class="container" id="container-main">Test</div>
</template>

<script>
const axios = require("axios");
const qs = require("querystring");

export default {
  name: "authcallback",
  data: function () {
    return {};
  },
  methods: {},
  mounted() {
    const requestBody = {
      grant_type: "authorization_code",
      client_id: "2pe012gc621jmrdh3mj7aurdbe",
      code: this.$route.query.code,
      redirect_uri: "http://localhost:8080/auth/callback",
    };

    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    axios
      .post("https://voiceauth.auth.eu-west-1.amazoncognito.com/oauth2/token", qs.stringify(requestBody), config)
      .then((result) => {
        localStorage.setItem("access_token", result.data.access_token);
        localStorage.setItem("id_token", result.data.id_token);
        localStorage.setItem("refresh_token", result.data.refresh_token);
        this.$router.push("/");
      })
      .catch((err) => {
        this.$router.push("/login");
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
